document.addEventListener('turbo:load', function() {
  const popup = document.getElementById('languageCriteriaPopup');
  const openButton = document.getElementById('openLanguageCriteriaPopup');
  const closeButtons = popup ? popup.querySelectorAll('.popup-close, .popup-cancel') : [];
  const saveButton = popup ? popup.querySelector('.popup-save') : null;
  const languageRadios = popup ? popup.querySelectorAll("input[name='languageType']") : [];

  if (!popup || !openButton) return;

  openButton.addEventListener('click', function(e) {
    e.preventDefault();
    popup.style.display = 'flex';
  });

  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      popup.style.display = 'none';
      resetForm();
    });
  });

  popup.addEventListener('click', function(e) {
    if (e.target === this) {
      this.style.display = 'none';
      resetForm();
    }
  });

  languageRadios.forEach(function(radio) {
    radio.addEventListener('change', handleLanguageTypeChange);
  });

  if (saveButton) {
    saveButton.addEventListener('click', handleSave);
  }

  function updateRadioStyles(selectedRadio) {
    popup.querySelectorAll('.custom-radio').forEach(function(radio) {
      radio.style.borderColor = '#eae5db';
      radio.style.background = 'white';
      radio.innerHTML = '';
    });

    if (selectedRadio) {
      const customRadio = selectedRadio.parentElement.querySelector('.custom-radio');
      if (customRadio) {
        customRadio.style.borderColor = '#1f8a5b';
        customRadio.style.background = '#1f8a5b';
        customRadio.innerHTML = '<span style="width: 8px; height: 8px; background: white; border-radius: 50%; display: block;"></span>';
      }
    }
  }

  function handleLanguageTypeChange(e) {
    updateRadioStyles(e.target);
  }

  function handleSave() {
    const languageRadio = popup.querySelector("input[name='languageType']:checked");
    if (!languageRadio) {
      alert("Please select a language.");
      return;
    }

    const language = languageRadio.value;
    const languageNames = {
      'swedish': 'Swedish',
      'norwegian': 'Norwegian',
      'finnish': 'Finnish'
    };

    const requirement = {
      type: 'language',
      language: language,
      display: languageNames[language]
    };

    if (typeof aiReviewFilters !== 'undefined' && aiReviewFilters.language_criteria) {
      aiReviewFilters.language_criteria = [];
      aiReviewFilters.language_criteria.push(requirement);
      if (typeof renderAddedItems === 'function') {
        renderAddedItems();
      }
    }

    popup.style.display = 'none';
    resetForm();
  }

  function resetForm() {
    languageRadios.forEach(function(radio) {
      radio.checked = false;
    });
    updateRadioStyles(null);
  }
});
